<template>
  <div class="main-container" v-if="platform == 'furioos'">
    <Furioos />
  </div>
  <div class="main-container" v-else-if="platform == 'aws'">
    <AWSAppStream />
  </div>
</template>
<script>
import Furioos from "./Furioos";
import AWSAppStream from "./AWSAppStream";
export default {
  name: "Main",
  components: { Furioos, AWSAppStream },
  data() {
    return {
      platform: "aws",
    };
  },
  created() {
    console.log("create");
    console.log(this.platform);
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Main.vue